import { useEffect, useRef, useState } from "react";
import listText from "../utils/dictionaries/dictionary-identification-questionnaire";
import Button from "../components/atoms/button";
import Top from "../components/templates/top";
import Link from "../components/atoms/link";
import Paragraph from "../components/atoms/paragraph";
import { useNavigate } from "react-router-dom";
import Checkbox from "../components/molecules/checkbox";
import TitleAndImage from "../components/molecules/title-and-image";
import insertDriveFileBgw from "../assets/icons/insert_drive_file_bgw.svg";
import DocsUtilService from "../services/docsUtil.service";
import { DocsUseCase } from "../../application/use-cases/docs.usecase";
import { store } from "../redux/store";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";
import AcceptAuthorizeUtilService from "../services/acceptAuthorizeUtil.service";
import { classAcceptAuthorizeUseCase } from "../../application/use-cases/acceptAuthorize.usecase";
import { dateISO } from "../utils/helpers";
import { BiometricValidation } from "../../application/use-cases/biometric-validation.usecase";
import ProcessContracts from "../services/processContracts.service";

const IdentificationQuestionnaire = () => {
  const navigate = useNavigate();
  const state = store.getState();
  const [activeSpinner, setActiveSpinner] = useState(false);
  const [checked, setChecked] = useState(false);
  const [, setSeconds] = useState<number>(0);
  const [toggle] = useState<boolean>(false);
  const ref = useRef<NodeJS.Timeout | null>(null);
  const [modalShow, setModalShow] = useState(false);
  const [somethingWentWrong, setSomethingWentWrong] = useState(true);
  const [biometricIneStatus, setBiometricIneStatus] = useState("");
  const [retries, setRetries] = useState<any>();

  const caseDocs = new DocsUtilService();
  const useCaseDocs = new DocsUseCase(caseDocs);

  const caseServiceAutorice = new AcceptAuthorizeUtilService();
  const useCaseAutorize = new classAcceptAuthorizeUseCase(caseServiceAutorice);

  const getBiometricIneData = new ProcessContracts();
  const useCaseGetBiometricIne = new BiometricValidation(getBiometricIneData);

  const continueProcess = async () => {
    const saveAcceptanceDoc = await useCaseAutorize.saveDocumentationAcceptances({
      processId: state.client.clientPersist.uuid,
      phone: state.client.dataPersist.phone,
      latitude: "",
      longitude: "",
      acceptanceDate: dateISO(),
    });
    if (saveAcceptanceDoc.error != null) {
      setModalShow(true);
    } else {
      navigate("/ContractCondition");
    }
  };

  const acceptAuthorize = (value: boolean) => {
    if (!somethingWentWrong) setChecked(!value);
  };

  const getBiometricIne = async () => {
    const response = await useCaseGetBiometricIne.getBiometricIne(state.client.clientPersist.uuid)
    setBiometricIneStatus(response.data.status)
    setRetries(response.data.retries)
  };

  useEffect(() => {
    ref.current = setInterval(() => {
      if (toggle) setSeconds((state) => state + 1);

      var condition = localStorage.getItem("conditionLiveness") == "false" ? false : true;

      if (!condition && biometricIneStatus !== null) {
        navigate("/LivenessCheck");
        localStorage.setItem("biometricValidation", biometricIneStatus);
        localStorage.setItem("retries", retries);
      }
    });

    return () => {
      if (ref.current) clearInterval(ref.current);
    };
  }, [toggle, biometricIneStatus, retries]);

  useEffect(() => {
    getBiometricIne()
  }, []);

  const getidentificationQuestionnaire = async () => {
    const doc = await useCaseDocs.getIdentificationQuestionnaireDoc(
      state.client.clientPersist.uuid,
    );
    if (doc.error == null) {
      window.open(doc.data.url);
      setSomethingWentWrong(false);
    } else {
      setSomethingWentWrong(true);
      setModalShow(true);
    }
  };

  const onClickButtonLink = () => {
    navigate("/FollowLater", {
      state: {
        resource: "/IdentificationQuestionnaire",
        step: "CONTINUE_AFTER",
        data: {
          processId: state.client.clientPersist.uuid,
          phone: state.client.dataPersist.phone,
          latitude: "",
          longitude: "",
          acceptanceDate: dateISO(),
        },
      },
    });
  };

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={listText.text_1.mainText}
          subTitle={listText.text_2.mainText}
          displayProgressBar={""}
          displayLeftImageTitle={"d-none"}
          classTitleImage={"ms-2"}
          classHeader={"mt-2"}
          styleHeader={{}}
          classProgressBar={"mt-3"}
          styleProgressBar={{}}
          classTitleAndImage={""}
          styleTitleAndImage={{}}
          valueProgressBar={"70%"}
          comeFrom={"/IdentificationQuestionnaire"}
          onClickGoBackIcon={undefined}
        />
        <div className="p-3">
          <Paragraph text={listText.text_3.mainText} className={""} styleParagraph={undefined} />
          <Paragraph text={listText.text_4.mainText} className={""} styleParagraph={undefined} />
          <div className={`text-center mt-5`} style={{ backgroundColor: "#F7F7F7" }}>
            <TitleAndImage
              srcImage={insertDriveFileBgw}
              titleText={listText.text_5.mainText}
              displayLeftImageTitle={""}
              classTitle={"m-2"}
              styleTitle={{
                color: "#004A94",
                fontSize: "18px",
                cursor: "pointer",
                fontWeight: 400,
                fontFamily: "Roboto",
              }}
              onClickTitleImgeDiv={getidentificationQuestionnaire}
              divClass={"py-3"}
            />
          </div>
          <div className="mt-5">
            <Checkbox
              text={listText.text_6.mainText}
              htmlFor={"flexCheckDefault"}
              classNameLabel={"fs-6"}
              classCheckbox={"form-check my-4_2"}
              checked={checked}
              onChange={() => {
                acceptAuthorize(checked);
              }}
            />
          </div>
        </div>
      </div>
      <div className="footer--pin">
        <Button
          text={listText.text_7.mainText}
          divClassName={"d-grid gap-2"}
          buttonClassName={`${!checked ? `button-disabled` : `button-enabled`
            } w-100 place-content-center align-self-center`}
          spinner={activeSpinner}
          onClick={() => {
            continueProcess();
          }}
          disabled={!checked}
          dataBsDismiss={undefined}
        />
        <div className="text-center mt-3">
          <Link
            text={listText.text_8.mainText}
            url={null}
            styleLink={{
              color: "#5A6172",
              lineHeight: "16px",
              textDecoration: "none",
              cursor: "pointer",
            }}
            onClick={() => onClickButtonLink()}
            className={""}
          />
        </div>
      </div>
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle={listText.text_24.mainText}
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: listText.text_25.mainText,
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => {
              setModalShow(false);
            },
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => setModalShow(false)}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph: listText.text_26.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: listText.text_27.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default IdentificationQuestionnaire;
